import { createBlobURL } from "../../dom";
import { getBlockProps } from "../blocks-parser";
import { every } from "lodash";

const imageSingleSchema = {
  img: {
    attributes: ["src", "alt", "title"],
    classes: [
      "alignleft",
      "aligncenter",
      "alignright",
      "alignnone",
      /^grigora-image-\d+$/,
    ],
  },
};

const props = {
  content: {
    source: "text",
    selector: "code",
  },
};

const imageFilesSchema = {
  blockSlug: "grigora/image",
  isMatch(files) {
    // The following check is intended to catch non-image files when dropped together with images.
    if (
      files.some((file) => file.type.indexOf("image/") === 0) &&
      files.some((file) => file.type.indexOf("image/") !== 0)
    ) {
      // Non image file found.
      return;
    }
    return every(files, (file) => file.type.indexOf("image/") === 0);
  },
  transform(files) {
    const blocks = files.map((file) => {
      return {
        blockSlug: "grigora/image",
        blockProps: {
          srcMode: "link",
          src: createBlobURL(file),
          srcActionTrigger: "upload",
        },
      };
    });
    return blocks;
  },
};

export { imageFilesSchema };
